import { useState } from "react";
import { api, type SandlotCustomerSummary } from "../app/api";

export function SandlotExplorerPage() {
  const [q, setQ] = useState("");
  const [rows, setRows] = useState<SandlotCustomerSummary[] | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function search(e: React.FormEvent) {
    e.preventDefault();
    if (!q.trim()) return;
    setLoading(true);
    setError(null);
    try {
      const res = await api.sandlotSearch(q.trim());
      setRows(res.customers);
    } catch (err) {
      setError(err instanceof Error ? err.message : String(err));
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      <h1>Sandlot Explorer</h1>
      <p className="page-sub">
        Search the staged Sandlot customer archive (read-only) by name or email.
      </p>

      <form onSubmit={search} style={{ display: "flex", gap: 8, marginBottom: 20 }}>
        <input
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder="name or email…"
          style={{
            flex: 1,
            padding: "0.5rem 0.7rem",
            background: "var(--surface)",
            border: "1px solid var(--hair)",
            borderRadius: 8,
            color: "var(--ink)",
          }}
        />
        <button
          type="submit"
          style={{
            padding: "0.5rem 1rem",
            background: "var(--accent)",
            color: "#12140f",
            border: "none",
            borderRadius: 8,
            fontWeight: 600,
            cursor: "pointer",
          }}
        >
          Search
        </button>
      </form>

      {loading && <p className="muted">Searching…</p>}
      {error && <p className="muted">{error}</p>}
      {rows && rows.length === 0 && <div className="empty">No matches (max 25 shown).</div>}

      {rows && rows.length > 0 && (
        <div className="card">
          <table>
            <thead>
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Phone</th>
                <th>Sandlot ID</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.id}>
                  <td>{r.name ?? "—"}</td>
                  <td className="muted">{r.email ?? "—"}</td>
                  <td className="muted">{r.phone ?? "—"}</td>
                  <td className="muted">
                    <code>{r.id}</code>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </>
  );
}
